import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { getCard } from "@components/OrderTaking/Helpers/card";

export function useCard(): void {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCard());
    }, []);
}
